import React, { useMemo } from 'react';
import { useLocation } from "react-router-dom";
import { useIntercom } from 'react-use-intercom';
import styles from './expiry.module.scss';
import logo from '../../components/auth-page-layout/logo.png';

function Expiry() {
  const { search } = useLocation();
  const { show } = useIntercom();
  
  const isExisting = useMemo(() => (new URLSearchParams(search)).get('existing'), [search])

  const openIntercom = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    show();
  }
  return (
    <div className={styles.page}>
      <div className={styles.body}>
        <img className={styles.logo} src={logo} alt="Logo"/>
        <div className={styles.textBody}>
          {isExisting ? (
            <p className={styles.title}>Your invite has expired as you already registered account. Please <a href='/login' style={{ color: 'white', textDecoration: 'underline' }}>Login</a>.</p>
          ): (
            <p className={styles.title}>The invitation link is invalid. Please ask your school administration to send you a new invite.</p>
          )}
          
          <p className={styles.title}>
            Alternatively, please contact <a onClick={openIntercom} href='/' style={{ color: 'white', textDecoration: 'underline' }}>OpenParachute support</a> and we can help send you a new invite.
          </p>
        </div>
        <div className={styles.footer}>
          © {(new Date().getFullYear()) || '2022'} Open Parachute Ltd. All rights reserved.
        </div>
      </div>
    </div>
  );
}

export default Expiry;
